import { module } from 'modujs';
import { lazyLoadImage } from '../utils/image';
import LocomotiveScroll from 'locomotive-scroll';
import Lenis from '@studio-freight/lenis'

export default class extends module {
    constructor(m) {
        super(m);
        this.observers = [];
        this.lenis = null;
    }

    init() {
        this.initIntersectionObservers();
        this.lenis = new Lenis()

        function raf(time) {
          if(this.lenis) {
            this.lenis.raf(time)
            requestAnimationFrame(raf.bind(this))
          }
        }
        
        requestAnimationFrame(raf.bind(this))
        /*
        this.scroll.on('scroll', (args) => {
          // Get all current elements : args.currentElements
          if(typeof args.currentElements['home-hero'] === 'object') {
            let progress = args.currentElements['home-hero'].progress;

            this.$('home-hero-small')[0].style.top = `${((progress - 0.47) * 50) + 50}%`;
            this.$('home-hero-large')[0].style.top = `${((progress - 0.47) * 25)}%`;
            // ouput log example: 0.34
            // gsap example : myGsapAnimation.progress(progress);
          }
        })*/

    }

    initIntersectionObservers() {
      this.destroyObservers();
      const scrollElements = document.querySelectorAll('[data-scroll]');
      scrollElements.forEach((entry) => {
        const scrollOption = entry.getAttribute('data-scroll');
        if(scrollOption !== 'slave') {
          this.observers.push(this.observeElement(entry));
        }
      });
    }

    destroyObservers() {
      this.observers.forEach((observer) => {
        observer.disconnect();
      })

      this.observers = [];
    }

    callElement(el) {
      if(el) {
        const callString = el.getAttribute('data-scroll-call');
        if(callString) {
          const func = callString.split(', ');
          this.call(func[0], { el }, func[1], func[2]);
        }
      }
    }

    observeElement(el) {
      const offset = el.getAttribute('data-scroll-offset');
      const threshold = offset ? +offset.replace('%','') / 100 : 0;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const scrollOption = entry.target.getAttribute('data-scroll');
            if (entry.isIntersecting) {
              if(scrollOption === 'children') {
                const childrenElements = entry.target.querySelectorAll('[data-scroll]');
                childrenElements.forEach((childEl) => {
                  this.callElement(childEl);
                });
              } else {
                this.callElement(entry.target);
              }
              
            }
          });
        },
        {
          threshold: threshold
          // rootMargin:"-50px"
        }
      );

      observer.observe(el);

      return observer;
    }

    /**
     * Lazy load the related image.
     *
     * @see ../utils/image.js
     *
     * It is recommended to wrap your `<img>` into an element with the
     * CSS class name `.c-lazy`. The CSS class name modifier `.-lazy-loaded`
     * will be applied on both the image and the parent wrapper.
     *
     * ```html
     * <div class="c-lazy o-ratio u-4:3">
     *     <img data-scroll data-scroll-call="lazyLoad, Scroll, main" data-src="http://picsum.photos/640/480?v=1" alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />
     * </div>
     * ```
     *
     * @param {LocomotiveScroll} args - The Locomotive Scroll instance.
     */
    lazyLoad(args) {
      lazyLoadImage(args.el, null, () => {
          //callback
      })
    }

    update() {
      this.initIntersectionObservers();
    }

    destroy() {
      this.destroyObservers();
      if(this.lenis) {
        this.lenis.destroy();
      }
    }
}
